<template>
    <a-select
        :get-popup-container="getPopupContainer"
        placeholder="请选择"
        allow-clear
        :value="value"
        @update:value="onUpdateValue"
        style="width: 100%"
        v-bind="$attrs"
    >
        <a-select-option
            v-for="item in options"
            :key="item[valueName]"
            :value="valueIsNumber ? parseInt(item[valueName]) : item[valueName]"
            :disabled="item.disabled ? item.disabled : false"
        >
            {{ item[titleName] }}
        </a-select-option>
    </a-select>
</template>

<script>
export default {
    name: "SingleSelect",
    emits: ["update:value"],
    props: {
        value: {
            type: [String, Number],
        },
        options: {
            type: Array,
            default() {
                return [];
            },
        },
        titleName: {
            type: String,
            default: "title",
        },
        valueName: {
            type: String,
            default: "value",
        },
        valueIsNumber: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, {emit}) {
        const onUpdateValue = (val) => {
            emit("update:value", val);
        };
        return {
            onUpdateValue,
        };
    },
};
</script>

<style scoped>
</style>
